import { apiClient } from '../axiosInstance';
import { ENDPOINTS } from '../endpoints';
import type { TokenService } from './interfaces/TokenService';
import type { TokenSession } from './interfaces/AuthService';

export const tokenService: TokenService = {
  async auth(token) {
    const { data } = await apiClient.get<TokenSession>(
      ENDPOINTS.v1.tokens.auth(token),
    );
    return data;
  },
};
